import { __assign } from "tslib";
import { getProGalleryStylesImp } from './proGalleryStyleBuilder';
export var HEIGHT_SET = {
    BY_CONTENT: 'content',
    BY_PARENT: 'parent',
    BY_BOTH: 'both',
};
var FIXED_GALLERY_RATIO = {
    FIXED_RATIO: 0,
    RELATIVE_RATIO: 1,
};
var SCROLL_DIRECTION = {
    VERTICAL: 0,
    HORIZONTAL: 1,
};
export var getProGalleryHeightSource = function (wixStyles, isMobile) {
    try {
        var defaultOptions = {
            isMobile: !!isMobile,
            isStoreGallery: false,
            isOnBoarding: false,
            isInEditor: false,
            isSsr: false,
        };
        var spreadStyles = __assign(__assign(__assign(__assign(__assign({}, wixStyles.booleans), wixStyles.numbers), wixStyles.colors), wixStyles.fonts), wixStyles.manual);
        var galleryStyles = getProGalleryStylesImp(spreadStyles, true, __assign({}, defaultOptions)); // wix to gallery
        // const presetStyles = addPresetStyles(galleryStyles); // preset funnel
        // const processedStyles = addLayoutStyles(presetStyles); // final processed styles
        // DESIGNED_PRESET: -2
        // EMPTY: -1,
        // COLLAGE: 0,
        // MASONRY: 1,
        // GRID: 2,
        // THUMBNAIL: 3,
        // SLIDER: 4,
        // SLIDESHOW: 5,
        // PANORAMA: 6,
        // COLUMN: 7,
        // MAGIC: 8,
        // FULLSIZE: 9,
        // BRICKS: 10,
        // MIX: 11,
        // ALTERNATE: 12,
        switch (galleryStyles.galleryLayout) {
            case 1:
            case 6:
            case 8:
            case 10:
            case 11:
            case 12:
                galleryStyles.scrollDirection = SCROLL_DIRECTION.VERTICAL;
                break;
            case 3:
            case 4:
            case 5:
            case 7:
            case 9:
                galleryStyles.scrollDirection = SCROLL_DIRECTION.HORIZONTAL;
                break;
            case -1:
            case 0:
            case 2:
                galleryStyles.scrollDirection =
                    galleryStyles.scrollDirection === undefined
                        ? SCROLL_DIRECTION.VERTICAL
                        : galleryStyles.scrollDirection;
                break;
            default:
                galleryStyles.scrollDirection = SCROLL_DIRECTION.VERTICAL;
                break;
        }
        // const processedStyles = addLayoutStyles(galleryStyles); // final processed styles
        if ((galleryStyles.scrollDirection === SCROLL_DIRECTION.VERTICAL &&
            !(galleryStyles.enableInfiniteScroll === false)) ||
            (galleryStyles.scrollDirection === SCROLL_DIRECTION.HORIZONTAL &&
                spreadStyles.allowFixedGalleryRatio ===
                    FIXED_GALLERY_RATIO.RELATIVE_RATIO)) {
            return HEIGHT_SET.BY_CONTENT;
        }
        else {
            return HEIGHT_SET.BY_PARENT;
        }
    }
    catch (e) {
        console.error('Cant get pro gallery height source', e);
        return null;
    }
};
//# sourceMappingURL=proGalleryHeightSourceHelper.js.map